module.exports = __webpack_public_path__ + "static/media/205-Pflegemassnahmen_ID_36.bc85a628.mp3";